import CreditChargeModal from "./CreditChargeModal";
import CreditWarningModal from "./CreditWarningModal";
import SupportModal from "./SupportModal";
import VoteModal from "./VoteModal";

const Modal = {
  CreditCharge: CreditChargeModal,
  CreditWarning: CreditWarningModal,
  Support: SupportModal,
  Vote: VoteModal,
};

export default Modal;
